<!--
 * @Date: 2020-08-13 09:35:27
 * @LastEditors: lingbinzzz
 * @LastEditTime: 2020-09-20 15:20:33
 * @FilePath: \pc-mall\src\views\paySucceed.vue
-->
<template>
  <div>
    <div class="main_box">
      <!-- 购票进度 -->
      <ProgressPanel :activitiesIndex='activitiesIndex'></ProgressPanel>
      <!-- <div class="title">预约成功</div> -->
      <div class="form">
        <img src="../assets/images/succeed.png" />
        <p class="link">
          <span @click="toPath('/')">{{$t('Backtohome')}}</span>
          <span class="nanputuo-confirm" @click="toPath('/myOrder', '2')">{{$t('Checkorder')}}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import CopyRight from '../components/CopyRight'
import ProgressPanel from '../components/ProgressPanel'

export default {
  components: {
    CopyRight,
    ProgressPanel
  },
  data () {
    return {
      visitorCertificateType:false,
      orderData:null,
      activitiesIndex: 6
    }
  },
  created () {
    if(this.$route.query.orderData){
      let orderData = JSON.parse(this.$route.query.orderData)
      this.orderData = orderData
      orderData.orderDetailList[0].orderVisitorList.forEach(item=>{
        if(item.visitorCertificateType!=='1'){
          this.visitorCertificateType = true
        }
      })
    }
  },
  methods: {
    toPath (path, index) {
        this.$router.push(path)
    }
  }
}
</script>

<style scoped lang="scss">
.title {
  font-size: 24px;
  line-height: 65px;
  font-weight: bold;
}

.visitor-certificate {
  span {
    display: block;
    text-align: center;
    margin: 10px 0;
  }
}
.form {
  border: 1px solid #ccc;
  height: 400px;
  padding: 114px 0px 100px 0px;
  margin-bottom: 40px;
  background-color: #fff;
  text-align: center;
}

.link {
  margin-top: 35px;
}

.link span {
  display: inline-block;
  width: 130px;
  height: 44px;
  background: rgba(246, 246, 246, 1);
  border-radius: 6px;
  line-height: 44px;
  margin: 0 20px;
  cursor: pointer;
  &.nanputuo-confirm {
    background: #241008 !important;
    color: #fff !important;
  }
}
.main_box {
  position: relative;
  .schedule {
    position: absolute;
    right: -185px;
    top: 0;
    .title {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 165px;
      height: 40px;
      background: #853D3F;
      color: #FFFFFF;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: bold;
    }
    .content {
      padding: 16px 16px;
      background: white;
      padding-right: 0;
      .activity {
        color: #853D3F;
      }
    }
  }
}
</style>
